import sitePages from "../Site/sitePages"
import utilityPages from "../Site/utilityPages"

function flatten(pages, section, acc) {
    pages.forEach((page) => {
        if (page.children?.length) {
            flatten(page.children, section, acc)
        } else if (page.component) {
            acc.push({to: page.to, title: page.title, section, component: page.component})
        }
    })
    return acc
}

export default function buildPageIndex() {
    return [
        ...flatten(sitePages, 'pages', []),
        ...flatten(utilityPages, 'utilities', [])
    ]
}
